import logo from "./logo.svg";
import "./App.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/home/Home";
import About from "./components/About/About";
import Navbar from "./components/common/navbar/Navbar";
import Footer from "./components/common/Footer/Footer";
import Gallery from "./components/gallery/Gallery";
import Service from "./components/service/Service";
import Contact from "./components/contact/Contact";
import Achievements from "./components/Achievement/Achievements";
import Syllabus from "./components/syllabus/Syllabus";
import Whatsapp from './components/whatsapp/Whatsapp';



function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/gallery" element={<Gallery />} />
          <Route exact path="/syllabus" element={<Syllabus/>}/>
          <Route exact path="/achievement" element={<Achievements />} />
          <Route exact path="/service" element={<Service />} />
          <Route exact path="/contact" element={<Contact />} />
        </Routes>
       <Whatsapp/>
        <Footer />
        {/* test check 1 */}
        {/* This is secnodn check 2  */}
      </Router>
    </>
  );
}

export default App;

// 2min ki ek chiz sikha rha hu tune usme 4 din khaye toh dekh liyo
